export enum LaucherThemeType {
  jump = 'jump',
  galaxy = 'galaxy',
  twinkle = 'twinkle',
  bounce = 'bounce',
  glass = 'glass',
}
